/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import ExpressionUtil from './ExpressionUtil';
import FormatSymbols from './FormatSymbols';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/expressions/v5/util/ExpressionUtil (static) // assembleCase, getLiteral, whenThen, escapeStringLiteral
//@import FormatSymbols (runtime) // getListSeparator

/**
 * Utility class for common binning methods.
 * @author  PASCALLacombe
 */
export default class BinExpressionUtil extends BaseMoserObject{

	/**
	 * Generates the bin label expression.
	 * @param {String[][]} bins
	 * @param {String} binIdentifier
	 * @return {String}
	 */
	static binLabel(bins, binIdentifier) {
		var expressions = [];
		for (var i = 0; i < bins.length; ++i) {
			expressions[i] = BinExpressionUtil.binLabelExpression(binIdentifier, i + 1, bins[i][0]);
		}
		return ExpressionUtil.assembleCase(expressions);
	}

	/**
	 * Create range bin label as a V5 expression: when ( binIdentifier = binNumber )  then ( thenValue )
	 * @param {String} binIdentifier
	 * @param {int} binNumber
	 * @param {String} thenValue
	 * @return {String}
	 */
	static binLabelExpression(binIdentifier, binNumber, thenValue) {
		var condition = binIdentifier;
		condition+=(" = ");
		condition+=(ExpressionUtil.getLiteral(binNumber));
		return ExpressionUtil.whenThen(condition, ExpressionUtil.getLiteral(ExpressionUtil.escapeStringLiteral(thenValue)));
	}

	/**
	 * Format a double value to a number of decimal places, this is needed to fix diffs between Java and JS
	 * @param {Number} x
	 * @param  decimalPlaces
	 * @return {String}
	 */
	static formatDouble(x, maxDecimalPlaces) {
		if (maxDecimalPlaces <= 0) {
			var intPart = Math.round(x);
			var value = "";
			value+=(intPart);
			return value;
		}
		var intPart = Math.floor(x);
		var value = "";
		value+=(intPart);
		value+=(".");
		var decimalPart = Math.round((x - intPart) * Math.pow(10, maxDecimalPlaces));
		var decimalPartSize = BinExpressionUtil._longToString(decimalPart).length;
		var padding = maxDecimalPlaces - decimalPartSize;
		for (var i = 0; i < padding; ++i) {
			value+=("0");
		}
		value+=(decimalPart);
		return value;
	}

	static _longToString(v) {
		var value = "";
		value+=(v);
		return value;
	}

	/**
	 * Create width-bucket V5 expression.
	 * @param {String} identifier
	 * @param {String} minimum
	 * @param {String} maximum
	 * @param {int} numberOfBins
	 * @return {String}
	 */
	static widthBucket(identifier, minimum, maximum, numberOfBins, locale) {
		var listSeparator = FormatSymbols.getListSeparator(locale);
		var expression = "width-bucket ( ";
		expression+=(identifier);
		expression+=(listSeparator);
		expression+=(" ");
		expression+=(minimum);
		expression+=(listSeparator);
		expression+=(" ");
		expression+=(maximum);
		expression+=(listSeparator);
		expression+=(" ");
		expression+=(numberOfBins);
		expression+=(" )");
		return expression;
	}

	/**
	 * This is a util class.
	 */
	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/BinExpressionUtil.js